<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col md="6">
              <!-- .first_name -->
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.name')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-27"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('edu_contents.name')"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- .first_name -->
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.name_en')"
                label-for="input-27"
              >
                <b-form-input
                  id="input-27"
                  v-model="newItem.name_en"
                  type="text"
                  :placeholder="$t('edu_contents.name_en')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.duration')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="duration"
                  vid="duration"
                  rules="required"
                >
                  <cleave
                    id="time"
                    v-model="newItem.duration"
                    class="form-control"
                    :raw="false"
                    :options="time"
                    :placeholder="$t('edu_contents.duration')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="input-group-27"
                :label="$t('edu_contents.code')"
                label-for="input-27"
              >
                <validation-provider
                  #default="{ errors }"
                  name="code"
                  vid="code"
                  rules="required"
                >
                  <b-form-input
                    id="time"
                    v-model="newItem.code"
                    class="form-control"
                    type="text"
                    :placeholder="$t('edu_contents.code')"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <!-- .last_name -->
              <b-form-group
                id="input-group-28"
                :label="$t('edu_contents.description')"
                label-for="input-28"
              >
                <validation-provider
                  #default="{ errors }"
                  name="description"
                  vid="description"
                  rules="required"
                >
                  <ckeditor
                    :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                    name="textarea"
                    v-model="newItem.description"
                    rows="4"
                    :placeholder="$t('edu_contents.description')"
                  ></ckeditor>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- .last_name -->
              <b-form-group
                id="input-group-28"
                :label="$t('edu_contents.description_en')"
                label-for="input-28"
              >
                <ckeditor
                  :config="{ contentsLangDirection: 'ltr',versionCheck : false }"
                  name="textarea"
                  v-model="newItem.description_en"
                  rows="4"
                  :placeholder="$t('edu_contents.description_en')"
                ></ckeditor>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row class="quiz" id="quiz" data-toggle="buttons">
            <b-col lg="3" v-for="item in types" :key="item.type" class="p-1">
              <b-button 
                :variant="'outline-' + item.color"
                @click="selectedType(item)"
                block
                :class="{ active: item.type == newItem.type }"
              >
                <feather-icon :icon="item.icon" />
                {{ item.title }}</b-button
              ></b-col
            >
          </b-row>
          <hr />
          <b-row>
            <b-col lg="12">
              <iframe
                v-if="
                  newItem.type == 'voice_lectures' ||
                  newItem.type == 'interactive_video_lectures'
                "
                ref="myIframe"
                :src="src"
                style="width: 100%; height: 800px"
                frameborder="0"
              ></iframe>
              <b-form-file
                v-else
                v-model="newItem.file"
                placeholder="اختيار ملف أو تسقطها هنا ..."
                drop-placeholder="إسقاط الملف هنا ..."
                :accept="accept"
                @change="previewImage($event)"
              />
            </b-col>
			

          </b-row>
          <b-row  v-if=" newItem.type == 'direct_lectures'">
		  	<b-col lg="6">
              <b-form-group id="input-group-5" :label="$t('edu_contents.allowattendance')" label-for="input-5" >
                <b-form-checkbox class="custom-control-primary" name="check-button" switch v-model="newItem.attendance" value="1" >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
              <!-- .number_of_questions -->
            </b-col>
			
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/EduContentController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import { required } from "@validations";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    Cleave,
  },
  mounted() {
    // Here we have the object of iframe

    window.addEventListener("message", this.handleMessage);
    if (
      this.newItem.type == "voice_lectures" ||
      this.newItem.type == "interactive_video_lectures"
    ) {
      this.iframeWin = this.$refs.myIframe.contentWindow;
    }
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      

      accept: "",
      time: {
        time: true,
        timePattern: ["h", "m"],
      },
      src: "",
      iframeWin: {},
      file: {},
    };
  },
  created() {
    this.types = new Controller(this.$route.params.EduCourse).Types(false);
   },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      console.log(this.newItem);
      let ret = await new Controller(this.$route.params.EduCourse).From(
        this.newItem,
        "FormData"
      );
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    handleMessage(event) {
      if (event.data.cmd) {
        this.newItem.h5p_content_id = event.data.params.contentId;
      }
    },
    selectedType(item) {
      console.log(item);
      //
      this.$set(this.newItem, "type", item.type);
      this.$set(
        this,
        "src",
        config.serverUrl + "/editor?type=" + this.newItem.type
      );
      switch (item.type) {
        case "uploaded_voice_lectures":
          this.accept = "audio/*";
          break;
        case "pdf":
          this.accept = "application/pdf";
          break;
        case "powerpoint_lectures":
          this.accept = ".ppt,.pptx";
          break;
        case "scrom_lectures":
          this.accept = ".zip,.rar";
          break;
        case "video_lectures":
          this.accept = "video/*";
          break;
      }
    },
  },
};
</script>

<style></style>
